import {BusinessConfig, BusinessService} from 'lib-components';
import {environment} from '../environments/environment';

export function businessConfigInitializer(businessService: BusinessService): Promise<BusinessConfig> {
    return businessService
        .fetchConfig(environment.publicApiUrl)
        .toPromise();
}
